import React from "react";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";

import Button from "../shared/Button";

const SuccessModal = ({ handleClose }) => {
  return (
    <Stack alignItems="center" pl={5} pr={1} py={5}>
      <img src="/assets/icons/complete-mapping.svg" alt="" />
      <Typography color="var(--text-color)" fontSize={24} fontWeight={700}>
        Document ajoutés & associés avec succès
      </Typography>
      <Typography color="var(--light-grey-text)" fontSize={14} fontWeight={500}>
        Les documents ont été correctement associés aux biens sélectionnés
      </Typography>
      <Alert
        icon={false}
        severity="success"
        sx={{
          mt: 3,
          px: 5,
          py: 2,
          mb: 4,
          border: "1px solid var(--dark-green)",
        }}
      >
        <Stack direction="row" alignItems="center">
          <Stack mr={3} direction="row">
            <Box>
              <Typography
                color="var(--text-color)"
                fontSize={17}
                fontWeight={700}
              >
                Où les retrouver ?
              </Typography>
              <Typography
                color="var(--light-grey-text)"
                fontSize={14}
                fontWeight={500}
              >
                Ils sont disponible dans la section "Mes documents".
              </Typography>
            </Box>
          </Stack>
          <Button
            color="success"
            variant="contained"
            style={{ width: "290px" }}
            onClick={handleClose}
          >
            <Typography fontSize={14} fontWeight={700}>
              Fermer
            </Typography>
          </Button>
        </Stack>
      </Alert>
    </Stack>
  );
};

export default SuccessModal;
